import React from "react";
import cn from "classnames";
import { EquipmentLabel } from "./EquipmentLabel";
import { Overlay, Popover } from "react-bootstrap";
import { EquipmentListItem } from "types/EquipmentListItem";

export const EquipmentListHoverCard: React.FC<{
    target: HTMLTableRowElement | null;
    equipment: EquipmentListItem;
    popperConfig: { modifiers: Array<{ name: string; options: { offset: () => [number, number] } }> };
}> = ({ target, equipment, popperConfig }) => (
    <Overlay show target={target} placement="bottom" flip popperConfig={popperConfig}>
        {(props) => (
            <Popover
                id="equipment-hover-card"
                className="bg-white shadow"
                {...props}
                style={{ ...props.style, minWidth: "20rem" }}
                arrowProps={{
                    ...props.arrowProps,
                    className: `d-none ${props.arrowProps?.className ?? ""}`.trim(),
                }}
            >
                <Popover.Body className="px-2 py-0">
                    <EquipmentHoverCard equipment={equipment} />
                </Popover.Body>
            </Popover>
        )}
    </Overlay>
);

const EquipmentHoverCard: React.FC<{
    equipment: EquipmentListItem;
}> = ({ equipment }) => {
    return (
        <div className="d-flex flex-column">
            <EquipmentLabel equipment={equipment} className="py-2" />
            <div className="d-flex flex-column border-top">
                <ListItem label="Make" value={equipment.manufacturer} isLast={!equipment.model && !equipment.serialNumber} />
                <ListItem label="Model" value={equipment.model} isLast={!equipment.serialNumber} />
                <ListItem label="Serial Number" value={equipment.serialNumber} isLast={true} />
            </div>
        </div>
    );
};

const ListItem: React.FC<{
    label: string;
    value: string | null;
    isLast: boolean;
}> = ({ label, value, isLast }) => {
    if (!value) {
        return null;
    }

    return (
        <div className={cn("d-flex align-items-baseline py-1", { "border-bottom": !isLast })}>
            <span className="fw-bold flex-shrink-0 w-150px">{label}</span>
            <span className="text-break small">{value}</span>
        </div>
    );
};
